import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { MfaMethodType } from 'lumen/utils/constants/mfa-constants';

interface SettingsPersonalMfaMethodSignature {
  Args: {
    mfaActiveMethod: MfaMethodType;
    updateMfaClicked: () => void;
  };
}

const SettingsPersonalMfaMethod = <template>
  <div class="flex justify-between" data-test-id="mfa-method">
    <div
      class="{{if
          @mfaActiveMethod.info
          'flex items-start justify-center'
          'flex items-center'
        }}
        gap-200"
    >
      <PrismIcon @name={{@mfaActiveMethod.icon}} />
      <div>
        <p class="text-300--bold" data-test-id="mfa-method-name">{{t
            @mfaActiveMethod.name
          }}</p>
        {{#if @mfaActiveMethod.info}}
          <p
            class="text-300--regular"
            data-test-id="mfa-method-info"
          >{{@mfaActiveMethod.info}}</p>
        {{/if}}
      </div>
    </div>
    <PrismButton
      @buttonType="secondary"
      @label={{t "general.update"}}
      @onClick={{@updateMfaClicked}}
      data-test-id="button-update-mfa"
    />
  </div>
</template> satisfies TOC<SettingsPersonalMfaMethodSignature>;

export default SettingsPersonalMfaMethod;
